import { reactive, ref } from "vue";
import { queryMyInitiativeList } from "@/api/myInitiative";

export default function useMyInitiativeTable() {
  // 搜索条件ref
  const searchRef = ref(null);

  // 搜索条件
  const searchData = reactive({
    processDefinitionName: "",
    processDefinitionKey: "",
    completeType: "",
  });

  // 表格loading
  const tableLoading = ref(false);

  // 表格数据
  const tableData = ref([]);

  // 表格列配置
  const columns = ref([
    {
      label: "流程id",
      prop: "processDefinitionId",
    },
    {
      label: "流程名称",
      prop: "processDefinitionName",
    },
    {
      label: "流程key",
      prop: "processDefinitionKey",
    },
    {
      label: "发起时间",
      prop: "startTime",
    },
    {
      label: "结束时间",
      prop: "endTime",
    },
    {
      label: "状态",
      prop: "completeType",
    },
  ]);

  // 分页数据
  const pages = reactive({
    page: 1,
    limit: 10,
    total: 0,
  });

  // 获取页面数据
  const getList = () => {
    tableLoading.value = true;
    queryMyInitiativeList({
      page: pages.page,
      limit: pages.limit,
      startTime: "2022-01-01 12:12:12",
      endTime: "2024-01-01 12:12:12",
      ...searchData,
    })
      .then((res) => {
        tableData.value = res.data?.records || [];
        pages.total = res.data?.total ?? 0;
      })
      .finally(() => {
        tableLoading.value = false;
      });
  };

  // 重置
  const handleReset = () => {
    searchRef.value?.resetFields();
    getList();
  };
  return {
    searchRef,
    searchData,
    tableLoading,
    tableData,
    columns,
    pages,
    getList,
    handleReset,
  };
}
